<mojo-widget [title]="widget.title" [showWidgetControls]="true" [widget]="widget">
  <ng-container widget-body>
    <div class="creditor-account-wrapper">
        <creditor-accounts-body [accounts]="accounts | async" (accountClick)="onAccountClicked($event)"></creditor-accounts-body>
    </div>
  </ng-container>
</mojo-widget>

